/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_User_SettingsInputs */

const en_import_user_settings = /** @type {(inputs: Import_User_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import User Settings`)
};

const fr_import_user_settings = /** @type {(inputs: Import_User_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer les paramètres utilisateur`)
};

const de_import_user_settings = /** @type {(inputs: Import_User_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzereinstellungen importieren`)
};

const it_import_user_settings = /** @type {(inputs: Import_User_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa impostazioni utente`)
};

const ru_import_user_settings = /** @type {(inputs: Import_User_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт пользовательских настроек`)
};

const es_import_user_settings = /** @type {(inputs: Import_User_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar configuración de usuario`)
};

const zh_cn2_import_user_settings = /** @type {(inputs: Import_User_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入用户设置`)
};

const ja_import_user_settings = /** @type {(inputs: Import_User_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザー設定をインポート`)
};

const hi_import_user_settings = /** @type {(inputs: Import_User_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता सेटिंग्स आयात करें`)
};

const pt_pt2_import_user_settings = /** @type {(inputs: Import_User_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar configurações do usuário`)
};

/**
* | output |
* | --- |
* | "Import User Settings" |
*
* @param {Import_User_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const import_user_settings = /** @type {((inputs?: Import_User_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_User_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_import_user_settings(inputs)
	if (locale === "de") return de_import_user_settings(inputs)
	if (locale === "it") return it_import_user_settings(inputs)
	if (locale === "ru") return ru_import_user_settings(inputs)
	if (locale === "es") return es_import_user_settings(inputs)
	if (locale === "zh-CN") return zh_cn2_import_user_settings(inputs)
	if (locale === "ja") return ja_import_user_settings(inputs)
	if (locale === "hi") return hi_import_user_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_import_user_settings(inputs)
	return en_import_user_settings(inputs)
});